import { render, staticRenderFns } from "./QuoteThankYou.vue?vue&type=template&id=2d2a75a3&scoped=true"
import script from "./QuoteThankYou.vue?vue&type=script&lang=js"
export * from "./QuoteThankYou.vue?vue&type=script&lang=js"
import style0 from "./QuoteThankYou.vue?vue&type=style&index=0&id=2d2a75a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2a75a3",
  null
  
)

export default component.exports